// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  Count,
  CountFromJSON,
  CountToJSON,
  ProjectSecret,
  ProjectSecretFromJSON,
  ProjectSecretToJSON,
  ProjectSecretPayload,
  ProjectSecretPayloadFromJSON,
  ProjectSecretPayloadToJSON,
  ProjectSecretResolvePayload,
  ProjectSecretResolvePayloadFromJSON,
  ProjectSecretResolvePayloadToJSON,
  ProjectSecretRevealResult,
  ProjectSecretRevealResultFromJSON,
  ProjectSecretRevealResultToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface CreateProjectSecretRequest {
  projectSecretPayload?: ProjectSecretPayload;
}

export interface DeleteProjectSecretRequest {
  id: number;
}

export interface GetProjectSecretRequest {
  id: number;
}

export interface GetProjectSecretsRequest {
  project: number;
  limit?: number;
  start?: number;
  sort?: string;
}

export interface GetProjectSecretsCountRequest {
  project: number;
}

export interface ResolveProjectSecretsRequest {
  projectSecretResolvePayload?: ProjectSecretResolvePayload;
}

export interface RevealProjectSecretRequest {
  id: number;
  project: number;
}

export interface UpdateProjectSecretRequest {
  id: number;
  projectSecretPayload?: ProjectSecretPayload;
}

/**
 * no description
 */
export class ProjectSecretsApi extends runtime.BaseAPI {
  /**
   * Secret to add (value will be encrypted at rest)
   * Create a new project secret
   */
  async createProjectSecretRaw(
    requestParameters: CreateProjectSecretRequest
  ): Promise<runtime.ApiResponse<ProjectSecret>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/projectsecrets`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ProjectSecretPayloadToJSON(requestParameters.projectSecretPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProjectSecretFromJSON(jsonValue)
    );
  }

  /**
   * Secret to add (value will be encrypted at rest)
   * Create a new project secret
   */
  async createProjectSecret(
    requestParameters: CreateProjectSecretRequest
  ): Promise<ProjectSecret> {
    const response = await this.createProjectSecretRaw(requestParameters);
    return await response.value();
  }

  /**
   * Deletes a specific project secret
   * Delete a project secret
   */
  async deleteProjectSecretRaw(
    requestParameters: DeleteProjectSecretRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteProjectSecret."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/projectsecrets/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Deletes a specific project secret
   * Delete a project secret
   */
  async deleteProjectSecret(
    requestParameters: DeleteProjectSecretRequest
  ): Promise<any> {
    const response = await this.deleteProjectSecretRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get a project secret by ID (without value)
   * Get a project secret
   */
  async getProjectSecretRaw(
    requestParameters: GetProjectSecretRequest
  ): Promise<runtime.ApiResponse<ProjectSecret>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getProjectSecret."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/projectsecrets/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProjectSecretFromJSON(jsonValue)
    );
  }

  /**
   * Get a project secret by ID (without value)
   * Get a project secret
   */
  async getProjectSecret(
    requestParameters: GetProjectSecretRequest
  ): Promise<ProjectSecret> {
    const response = await this.getProjectSecretRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get project-scoped secrets (values are never returned in list view)
   * Get list of project secrets
   */
  async getProjectSecretsRaw(
    requestParameters: GetProjectSecretsRequest
  ): Promise<runtime.ApiResponse<Array<ProjectSecret>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getProjectSecrets."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/projectsecrets`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ProjectSecretFromJSON)
    );
  }

  /**
   * Get project-scoped secrets (values are never returned in list view)
   * Get list of project secrets
   */
  async getProjectSecrets(
    requestParameters: GetProjectSecretsRequest
  ): Promise<Array<ProjectSecret>> {
    const response = await this.getProjectSecretsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get count of secrets for a project
   * Get project secrets count
   */
  async getProjectSecretsCountRaw(
    requestParameters: GetProjectSecretsCountRequest
  ): Promise<runtime.ApiResponse<Count>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getProjectSecretsCount."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/projectsecrets/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Get count of secrets for a project
   * Get project secrets count
   */
  async getProjectSecretsCount(
    requestParameters: GetProjectSecretsCountRequest
  ): Promise<Count> {
    const response = await this.getProjectSecretsCountRaw(requestParameters);
    return await response.value();
  }

  /**
   * Given an array of secret names and a project ID, returns a map of secret name to decrypted value. Used by the execution engine and QA Copilot to substitute secret references in test steps.
   * Resolve multiple project secrets
   */
  async resolveProjectSecretsRaw(
    requestParameters: ResolveProjectSecretsRequest
  ): Promise<runtime.ApiResponse<{ [key: string]: string }>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/projectsecrets/resolve`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ProjectSecretResolvePayloadToJSON(
        requestParameters.projectSecretResolvePayload
      ),
    });

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Given an array of secret names and a project ID, returns a map of secret name to decrypted value. Used by the execution engine and QA Copilot to substitute secret references in test steps.
   * Resolve multiple project secrets
   */
  async resolveProjectSecrets(
    requestParameters: ResolveProjectSecretsRequest
  ): Promise<{ [key: string]: string }> {
    const response = await this.resolveProjectSecretsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Decrypt and return the secret value. Requires secretViewValue permission.
   * Reveal a project secret value
   */
  async revealProjectSecretRaw(
    requestParameters: RevealProjectSecretRequest
  ): Promise<runtime.ApiResponse<ProjectSecretRevealResult>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling revealProjectSecret."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling revealProjectSecret."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/projectsecrets/{id}/reveal`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProjectSecretRevealResultFromJSON(jsonValue)
    );
  }

  /**
   * Decrypt and return the secret value. Requires secretViewValue permission.
   * Reveal a project secret value
   */
  async revealProjectSecret(
    requestParameters: RevealProjectSecretRequest
  ): Promise<ProjectSecretRevealResult> {
    const response = await this.revealProjectSecretRaw(requestParameters);
    return await response.value();
  }

  /**
   * Secret to update
   * Update a project secret
   */
  async updateProjectSecretRaw(
    requestParameters: UpdateProjectSecretRequest
  ): Promise<runtime.ApiResponse<ProjectSecret>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateProjectSecret."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/projectsecrets/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ProjectSecretPayloadToJSON(requestParameters.projectSecretPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProjectSecretFromJSON(jsonValue)
    );
  }

  /**
   * Secret to update
   * Update a project secret
   */
  async updateProjectSecret(
    requestParameters: UpdateProjectSecretRequest
  ): Promise<ProjectSecret> {
    const response = await this.updateProjectSecretRaw(requestParameters);
    return await response.value();
  }
}
